var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.features
    ? _c("div", {
        staticClass: "tab-pane",
        attrs: { id: "features-tab" },
        domProps: { innerHTML: _vm._s(_vm.features) }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }